/*import {createStore} from 'vuex'
import account from "@/store/account";
import alerts from './alerts';

export default createStore({
    state: {},
    mutations: {},
    actions: {
        initialiseStore({commit}) {
            commit('account/init')
            console.log('Store initialised...')
        }
    },
    modules: {
        account,
        alerts
    },
    strict: process.env.NODE_ENV !== 'production',
})*/


import {createStore} from 'vuex'
import createAlerts from './alerts';
import createAccount from './account';
import createEvent from './event';
import createUserEvents from './userEvents';
import createSchool from './schools';

export default api => {
    return createStore({
        actions: {
            initialiseStore({dispatch}) {
                dispatch('account/init')
                dispatch('school/init')
            }
        },
        modules: {
            alerts: createAlerts(),
            account: createAccount(api.account),
            event: createEvent(api.events),
            school: createSchool(api.schools),
            user_events: createUserEvents(api.user_events),
        },
        strict: process.env.NODE_ENV !== 'production'
    });
}